var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTwitterIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 41,
    viewBox: "0 0 42 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2131_16863)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.1143 29.0416L19.279 21.8786M19.279 21.8786L12.1143 11.9583H16.8583L22.0345 19.1231L29.1976 11.9583M19.279 21.8786L24.4518 29.0416H29.1976L22.0328 19.1214",
    stroke: "black",
    strokeWidth: 2.5625,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.7389 20.5C37.7389 29.9351 30.0907 37.5833 20.6556 37.5833C11.2205 37.5833 3.57227 29.9351 3.57227 20.5C3.57227 11.0649 11.2205 3.41666 20.6556 3.41666C30.0907 3.41666 37.7389 11.0649 37.7389 20.5Z",
    stroke: "black",
    strokeWidth: 2.5625,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.6553 0C31.9888 0 41.1553 9.16643 41.1553 20.5C41.1553 31.8336 31.9888 41 20.6553 41C9.3217 41 0.155273 31.8336 0.155273 20.5C0.155273 9.16643 9.3217 0 20.6553 0ZM16.9067 31.3064C25.9853 31.3064 30.9638 23.78 30.9638 17.2493V16.605C31.9303 15.9021 32.7796 15.0236 33.4238 14.0279C32.5453 14.4086 31.5788 14.6721 30.5831 14.8186C31.6081 14.2036 32.3988 13.2371 32.7503 12.095C31.7838 12.6514 30.7296 13.0614 29.6167 13.2957C28.7088 12.3293 27.4203 11.7436 26.0146 11.7436C23.291 11.7436 21.0653 13.9693 21.0653 16.6929C21.0653 17.0736 21.0946 17.4543 21.2117 17.8057C17.1117 17.6007 13.451 15.6386 11.0203 12.6514C10.6103 13.3836 10.3467 14.2329 10.3467 15.1407C10.3467 16.8393 11.2253 18.3621 12.5431 19.2407C11.7231 19.2407 10.9617 19.0064 10.3174 18.6257V18.6843C10.3174 21.0857 12.016 23.0771 14.271 23.5457C13.861 23.6629 13.4217 23.7214 12.9824 23.7214C12.6603 23.7214 12.3674 23.6921 12.0453 23.6336C12.6603 25.5957 14.5053 27.0307 16.6431 27.06C14.9446 28.3779 12.8067 29.1686 10.4931 29.1686C10.0831 29.1686 9.70242 29.1686 9.3217 29.11C11.4888 30.5157 14.0953 31.3357 16.8774 31.3357",
    fill: "#0062A7"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2131_16863"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 41,
    height: 41,
    fill: "white",
    transform: "translate(0.155273)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitterIcon);
export default __webpack_public_path__ + "static/media/twitter-icon.efdafb88309acb60e5707889da5d25cc.svg";
export { ForwardRef as ReactComponent };